import { ComponentRoute } from '@/classes'

const ErrorLogRoutes = {
  ErrorLogListView: new ComponentRoute('/errorlogs', 'ErrorLogListView'),
  ErrorLogDetail: new ComponentRoute('/errorlogs/:id', 'ErrorLogDetail')
}

export default ErrorLogRoutes
